import React, { useEffect, useState } from 'react';
import { fetchSitemapsStatus, formatSeoApiError } from '../../../utils/adminSeo';

export default function SeoSitemapsScreen() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    setErr('');
    fetchSitemapsStatus()
      .then(setData)
      .catch((e) => setErr(formatSeoApiError(e)));
  }, []);
  if (err) return <p className="text-red-600">{err}</p>;
  if (!data) return <p>Loading…</p>;
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Sitemap Manager</h2>
      <p className="text-sm">Index: {data.index_url}</p>
      <ul className="text-sm space-y-2">
        {(data.sitemaps || []).map((s) => (
          <li key={s.path} className="bg-white border rounded p-3">
            {s.path} — <strong>{s.url_count}</strong> URLs ({s.page_type})
          </li>
        ))}
      </ul>
    </div>
  );
}
